import { Component, type ReactNode } from "react";

import { reportClientCrash } from "../lib/client-telemetry.js";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

// Без error boundary любой throw в reducer (например на неожиданный
// payload chat.messageUpserted после форварда) уносит весь App,
// и юзер видит только фоновый градиент :root — «синий экран». Здесь
// ловим, логируем и даём кнопку reload без потери persisted-аккаунта.
export class AppErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }): void {
    console.error("[tg-client] uncaught render error", error, info.componentStack);
    // Ошибку рендера видит только консоль саппорта — дублируем в журнал
    // «Нагрузки», иначе о падении никто не узнает.
    reportClientCrash(error.message || "render error", error.stack);
  }

  private readonly handleReload = (): void => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  private readonly handleDismiss = (): void => {
    this.setState({ error: null });
  };

  render(): ReactNode {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <main className="app-shell">
        <section className="error-boundary">
          <div className="error-boundary__card">
            <h1>Что-то пошло не так</h1>
            <p className="error-boundary__message">
              {this.state.error.message || "Неизвестная ошибка рендера."}
            </p>
            <div className="error-boundary__actions">
              <button type="button" onClick={this.handleDismiss}>
                Попробовать продолжить
              </button>
              <button type="button" onClick={this.handleReload}>
                Перезагрузить
              </button>
            </div>
          </div>
        </section>
      </main>
    );
  }
}
